module.exports = __webpack_public_path__ + "img/advertise002.916321fb.png";